
/**
 * key: Used by the TradeInIntent component as the value we return
 * label: Used by the TradeInIntent component as the value to display to the user.
 */
 export const tradeInIntents = [
    {key: "Yes",  label: "Yes"}, 
    {key: "No", label: "No"}
];